/* globals $ Craft */

export default class CategorisedArticles {
  constructor($elem) {
    this.$elem = $elem;
    this.$form = $elem.find("form");
    this.offset = 5;
    this.loading = false;
    this.init();
  }

  init() {
    this.$form.submit((e) => {
      e.preventDefault();
      this.filter();
    });

    this.$form.find("select, input").change(() => {
      this.offset = 0;
      this.$elem.find(".articles-list").html("");
      this.filter();
    });

    this.$elem.find(".load-more").click((e) => {
      e.preventDefault();
      this.filter();
    });
  }

  filter() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    let data = this.$form.serialize() + "&offset=" + this.offset;
    $.ajax({
      url: Craft.currentSite.baseUrl + "?action=swissmed/articles/load-more",
      data: data,
    }).done((data) => {
      this.loading = false;
      this.offset += 5;
      this.$elem.find(".articles-list").append(data.data);
      if (!data.hasMore) {
        this.$elem.find(".load-more").fadeOut("fast");
      } else {
        this.$elem.find(".load-more").fadeIn("fast");
      }
    });
  }
}
